<template>
  <div :style="`width:${dispW}px; height:${dispH}px;color:white;overflow:hidden;`">
    <el-container style="line-height: 0px">
      <el-container>
        <el-main :height="`${dispH}px`" style="padding: 0px">
          <el-row>
            <MeridianFigure
              :mapValues="mapValues"
              :dispW="dispW"
              :dispH="dispH / 2 + 40"
            ></MeridianFigure>
          </el-row>
          <el-row>
            <el-col :span="12">
              <MapForm
                :isSelectVisibleBoolen="false"
                parentForm="factorforms"
                :indexInForm="0"
                :index="0"
                :dispW="dispW / 2"
                :dispH="dispH / 2 - 60"
                :colorBarWidth="90"
                :colorBarHeight="dispH / 2 - 65"
                :mapValues="mapValues"
              ></MapForm>
            </el-col>
            <el-col :span="12">
              <MapForm
                :isSelectVisibleBoolen="false"
                parentForm="factorforms"
                :indexInForm="1"
                :index="1"
                :dispW="dispW / 2"
                :dispH="dispH / 2 - 60"
                :mapValues="mapValues"
                :colorBarWidth="90"
                :colorBarHeight="dispH / 2 - 65"
              ></MapForm>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import MapForm from "./MapForm";
import MeridianFigure from "./MeridianFigure";
export default {
  name: "MainMeridian",
  mounted: function () {
    this.$emit("hide-waiting");
  },
  props: {
    dispW: {
      type: Number,
      default: window.screen.width - 30 - 500
    },
    dispH: {
      type: Number,
      default: window.screen.height - 80 - 30
    },
    mapValues: {
      type: Object,
      default: () => {}
    },
    value: Boolean
  },
  components: {
    MapForm,
    MeridianFigure
  },

  watch: {},
  computed: {},
  methods: {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/topography/components/MainMeridian.vue